// TODO: some css in app.css move to its owm file eventually
import PropTypes from 'prop-types'
import './FormLoaderStyle.css'

function FormLoader({ message }) {
  return (
    <div className="text-neutral-100 loaderWrapper">
      <strong>{message}</strong>
      <div className="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )
}
FormLoader.propTypes = {
  message: PropTypes.string.isRequired,
}
export default FormLoader
